<template>
  <NavBar>
    <template #buttonsLeft v-if="is_logged_in && $route.name !== 'Simulation' && location !== 'HistProject'">
      <NavigationButton
        tooltip="Projects"
        ticon="construction-crane"
        icon="domain"
        route="ProjectOverView"/>
      <NavigationButton
        tooltip="Workbench"
        ticon="workbench"
        icon="takt_workbench"
        route="WorkBench"/>
      <NavigationButton
        ref="test1"
        :disabled="!hasPermission('Business READ')"
        tooltip="Company"
        ticon="company"
        icon="takt_company"
        route="CompanyHome"
        />
      <NavigationButton
        ref="test2"
        v-if="hasOneOfPermissions([
          'Stats READ',
          'Community State READ ALL',
          'Community State READ ALL',
          'Application READ',
          'Project Invite READ ALL',
          'Subscriber READ',
          'BUG READ ALL'
        ])"
        tooltip="Dashboard"
        icon="dashboard"
        route="Dashboard"
        />
      <NavigationButton
        ref="test3"
        v-if="hasPermission('AI TAKTING')"
        tooltip="AI"
        icon="extension"
        route="AIDashboard"
        />
    </template>
    <template #buttonsMiddle v-if="isCloudPrint">
      <ProjectTitle
        v-if="$route.matched[0] && $route.matched[0].name === 'Project'"
        :text="getProject($route.params.project_id).name + ': ' + 'CLOUD.print - ' + $store.state.Auth.cloudprint_cache.name"
        />
    </template>
    <template #buttonsMiddle v-else-if="$route.name === 'Simulation'">
      <LocaleChanger></LocaleChanger>
    </template>
    <template #buttonsMiddle v-else-if="isLoading && $route.name !== 'ProjectOverView'">
      <v-progress-circular :size="24" indeterminate color="primary"></v-progress-circular>
      Loading Project...
    </template>


    <template #buttonsMiddle v-else-if="is_logged_in">
      <div style="display: flex; flex-direction: row">
      <v-btn
        class="text-none"
        outlined
        v-if="hasPermission('Project CREATE') && !hasBusinessPermission('Block ProjectCreation') && $route.name === 'ProjectOverView' && !isLoadingProjectOverview"
        @click="setDialogNewProjectShow(true)"
        >
        <v-icon>
          add
        </v-icon>
        <TText
          style="padding-left: 10px"
          value="Project"
          font_weight="500"
          large
        />
      </v-btn>
      <div v-else-if="$route.name === 'ProjectOverView' && isLoadingProjectOverview" style="display: flex; flex-direction: row; gap: 5px">
        <v-progress-circular :size="24" indeterminate color="primary"></v-progress-circular>
        <TText
          style="padding-left: 10px"
          value="Loading_Project_Overview..."
          font_weight="500"
          large
        />
      </div>
      <template v-if="location === 'HistProject'">
        <TTooltip
          :value="getToolTip({pro_account: true, disabled: !hasPermission('Taktprint CREATE'), name: 'TAKT.prints'})"
        >
          <v-btn
            class="mr-2"
            icon
            :disabled="!hasPermission('Taktprint CREATE')"
            small
            @click="openPrintDialog()"
          >
            <v-icon v-if="!$store.state.View.is_printing_mode_loading">
              print
            </v-icon>
            <v-progress-circular v-else indeterminate size="24" width="4"/>
          </v-btn>
        </TTooltip>
        <v-menu offset-y style="z-index: 20">
          <template v-slot:activator="{ on: menu }">
            <v-btn
              class="text-none"
              outlined
              v-on="{ ...menu }"
            >{{ getUObject({type:'histprojects', id: $route.params.histproject_id}).hist_name ? getUObject({type:'histprojects', id: $route.params.histproject_id}).hist_name : getUObject({type:'histprojects', id: $route.params.histproject_id}).hist_date }} <v-icon>keyboard_arrow_down</v-icon></v-btn>
          </template>
         <v-list class="histproject-dropdown">
           <!-- v-for="histproject in getUObjectsFiltered({ type: 'histprojects', filter: { entity_id: $route.params.project_id }})" -->
           <v-list-item
             v-for="histproject in getUObjects({ type: 'histprojects', ids: getUObject({type:'projects', id: $route.params.project_id}).histprojects })"
             :key="`histproject${histproject.id}`"
             @click="$router.push({name: 'HistProjectTaktPlan', params: { histproject_id: histproject.id }})"
           >
            <v-list-item-title>{{ histproject.hist_name ? histproject.hist_name : histproject.hist_date }}</v-list-item-title>
           </v-list-item>
         </v-list>
        </v-menu>
      </template>

<template v-else>
    <v-btn small class="mr-2" v-if="( $route.matched[1] && ['ProjectTaktPlan'].includes($route.matched[1].name) ) || ( $route.matched[0] && ['MultiProjectSchedule'].includes($route.matched[0].name) )" @click="setTokenView(!$store.state.View.isTokenView)"
        :color="$store.state.View.isTokenView ? 'green' : ''">
        <TText style="" value="TOKEN" font_weight="400" small />
    </v-btn>
    <v-btn small class="mr-2" v-if="$route.matched[0] && ['MultiProjectSchedule'].includes($route.matched[0].name)" @click="setValue({key: 'isMPStatusView', value: !$store.state.View.isMPStatusView})" :color="$store.state.View.isMPStatusView ? 'green' : ''">
        <TText style="" value="MACRO" font_weight="400" small />
    </v-btn>
    <v-btn small class="mr-2" v-if="$route.matched[1] && ['ProjectTaktPlan'].includes($route.matched[1].name)" @click="setValue({key: 'isMacroView', value: !$store.state.View.isMacroView})" :color="$store.state.View.isMacroView ? 'green' : ''">
        <TText style="" value="MACRO" font_weight="400" small />
    </v-btn>
    <v-btn small class="mr-2" v-if="$route.matched[0] && ['MultiProjectSchedule'].includes($route.matched[0].name)" @click="toggleMultiprojectWeekends()" :color="$store.state.View.multiproject_skip_weekends ? 'green' : ''">
        <TText style="" value="Hide Weekends" font_weight="400" small />
    </v-btn>
    <span v-if="showPrintButton()">
              <TTooltip
                :value="getToolTip({pro_account: true, disabled: !hasPermission('Taktprint CREATE'), name: 'TAKT.prints'})"
              >
                <v-btn
                  class="mr-2"
                  icon
                  :disabled="!hasPermission('Taktprint CREATE')"
                  small
                  @click="openPrintDialog()"
                >
                  <v-icon v-if="!$store.state.View.is_printing_mode_loading">
                    print
                  </v-icon>
                  <v-progress-circular v-else indeterminate size="24" width="4"/>
                </v-btn>
              </TTooltip>
            </span>
    <span v-if="$route.matched[1] && ['ProjectTaktPlan'].includes($route.matched[1].name)">
              <TTooltip :value="getToolTip({pro_account: !hasPermission('Cloudprint READ'), disabled: !hasPermission('Cloudprint READ') || !hasProjectPermission({project_id: $route.params.project_id, ppermission: 'Read Cloudprints'}), name: 'CLOUD.prints'})">
                <v-btn
                  icon
                  small
                  :disabled="!hasPermission('Cloudprint READ') || !hasProjectPermission({project_id: $route.params.project_id, ppermission: 'Read Cloudprints'})"
    
                  @click="$router.push({name: $route.matched[1].name === 'ProjectTaktPlan'?'TaktPlanCloudPrints':'TaktWalletCloudPrints'})"
                >
                  <v-icon>
                    cloud_upload
                  </v-icon>
                </v-btn>
              </TTooltip>
            </span>
    <TTooltip style="margin-left: 5px;" :value="'Roadblocks'" v-if="$route.matched[1] && ['ProjectTaktPlan'].includes($route.matched[1].name)">
        <v-btn icon small @click="$router.push({name: 'Roadblocks'})">
            <TIcon name="exclamation-triangle" />
        </v-btn>
    </TTooltip>
    <v-btn icon small v-if="$route.matched[1] && ['ProjectTaktPlan'].includes($route.matched[1].name) && $store.state.Ultra.projects[$route.params.project_id].status === 'live'" @click="$router.push({name: 'TaktPlanHistoryProjects'})">
        <v-icon>
            history
        </v-icon>
    </v-btn>
    <v-btn small class="mr-2" v-if="$route.matched[1] && $route.matched[1].name === 'ProjectWallet'" @click="
              $store.state.View.isMicroView && $store.state.View.wallet_show_workpackages_cache ? $router.push({
                  name: 'ProjectWalletTakt'
                }) : $route.name === 'ProjectWalletWorkPackageInfo' ? $router.push({
                  name: 'ProjectWalletTakt'
                }) : '';
              ;
              setMicroView({value: !isMicroView, project_id: $route.params.project_id, takt_index: $route.params.takt_index}); 
              
              " :color="$store.state.View.isMicroView ? 'green' : ''">
        <TText style="" value="MICRO" font_weight="400" small />
    </v-btn>
    <template v-if="$route.name === 'MultiProjectSchedule' && $store.state.View.multiproject_flexbar_visible">
              <ToggleCapsule
                :is_active="$store.state.View.multiproject_flexbar_color_mode"
                background_color="#121212"
                foreground_color="#FFF"
                @toggleClicked="setValue({ key: 'multiproject_flexbar_color_mode', value: !$store.state.View.multiproject_flexbar_color_mode})"
              />
              <TText style="margin-left: 5px;" value="FLEXBAR.color_mode_(long_calculation_time)" />
</template>

        <ProjectTitle
        v-if="$route.matched[0] && $route.matched[0].name === 'Project'"
        :text="getProject($route.params.project_id).name"
        />
        <ProjectMenu
        v-if="$route.matched[0] && $route.matched[0].name === 'Project'"
        :project_id="$route.params.project_id"
        />
      </template>
      </div>
      <WalletNavigation
        class="ml-2 mr-2"
        :today_disabled="getCurrentTaktIndex($route.params.project_id) === false?true:false"
        :project_start="getProjectStart($route.params.project_id)"
        :selected_date="getDateFromTaktIndex({
          project_id: $route.params.project_id,
          takt_index: $route.params.takt_index,
          chronology: 'before',
        })"
        v-if="$route.matched[1] && $route.matched[1].name === 'ProjectWallet'"
        @back="$router.push({
          name: 'ProjectWalletTakt',
          params: {
            takt_index: parseInt($route.params.takt_index) - parseInt(1),
            direction: 'left'
          }
          })"
        @foreward="$router.push({
          name: 'ProjectWalletTakt',
          params: {
            takt_index: parseInt($route.params.takt_index) + parseInt(1),
            direction: 'right',
          }
          })"
        @selectDate="selectWalletDate($event)"
        />
        <v-btn
          v-if="$route.matched[1] &&
            ($route.matched[1].name === 'ProjectTaktPlan' ||
            $route.matched[1].name === 'ProjectWallet') &&
            (
              getOwnTWorkPackages($route.params.project_id) &&
              getOwnTWorkPackages($route.params.project_id).length !== 0
            )
            "
          @click="setShowOwnWps(!isShowOwnWps)"
          :color="isShowOwnWps?'grey darken-3':''"
          >
          {{$t('AppLayout.NavBar.Desktop.ShowWps')}}
        </v-btn>
    </template>
    <template #tools>
      <NavBarTools v-if="is_logged_in"/>
    </template>
    <template #taktSlider>

      <TaktPlanZoom
        v-if="($route.matched[1] && $route.matched[1].name === 'ProjectTaktPlan') || $route.name === 'MultiProjectSchedule' || location === 'HistProject'"
        :value="$route.name.includes('Multi') ? multiproject_taktplan_zoom : taktplan_zoom"
        @selectZoom="handleSelectZoom($event)"
        />

    </template>
    <template #editbtn>
      <div style="display: flex;align-items: center;" class="ml-1" v-if="$route.matched[1] &&
          ($route.matched[1].name === 'ProjectTaktPlan' || $route.name === 'ProjectWorkPackageList') 
          &&
          hasProjectPermission({
            project_id: $route.params.project_id,
            ppermission: 'Read Project information'
            })">
        <TTooltip :value="$store.state.SnackBar.snackbar.disabled ? 'Enable SnackBar' : 'Disable SnackBar'" v-if="$route.name !== 'ProjectWorkPackageList'" >
          <ButtonOutlined @click.native="updateSnackbar({ disabled: !$store.state.SnackBar.snackbar.disabled })" icon="scale-up" width="36" height="36" :color="$store.state.SnackBar.snackbar.disabled ? 'orange': ''" />
        </TTooltip>
        <TTooltip value="Undo" class="ml-1">
          <ButtonOutlined :is_disabled="$store.state.Ultra.action_stack.length === 0" @click.native="undoLastAction()" icon="arrow-left" width="36" height="36"  >
            <template #text>
              <StandardBadge
                v-if="$store.state.Ultra.action_stack.length"
                :text="$store.state.Ultra.action_stack.length"
                color="primary"
                content_color="secondary"
            />
            </template>
          </ButtonOutlined>
        </TTooltip>
        <div class="edit-btn-inline">
            <EditButton
            v-if="getCurrentProjectActiveEditor === false || getCurrentProjectActiveEditor.id === getUserLiveSync.id"
            :isEditMode="isEditMode"
            @click.native="handleEditMode()"
            />
            <v-avatar class="ml-1" color="grey" size="32" v-else>
                <v-img v-if="getCurrentProjectActiveEditor.image !== 'noimage'" :src="getCurrentProjectActiveEditor.image" />
                <span v-else class="white--text pl-2">{{getCurrentProjectActiveEditor.first_name[0].toUpperCase() + getCurrentProjectActiveEditor.last_name[0].toUpperCase()}}</span>
            </v-avatar>
          </div>
        <v-menu offset-y v-if="$route.matched[1] && $route.matched[1].name === 'ProjectTaktPlan' && hasPermission('Use Live Sync') && getLiveSyncSettingFromCookie">
            <template v-slot:activator="{ on }">
                <v-btn icon  v-on="on">
                  <v-icon>perm_identity</v-icon>
                  <StandardBadge
                  v-if="getCurrentProjectActiveUsers.length !== 0"
                  :text="getCurrentProjectActiveUsers.length"
                  :zoom="1"
                  color="white"
                  content_color="black"
                  />
                </v-btn>
            </template>
            <StandardMembersList
            :members="getCurrentProjectActiveUsers"
            :selected_index="-1"
            :current_user="getUserLiveSync"
            />
        </v-menu>
      </div>

    </template>
    <template #ifc_upload v-if="$route.matched[1] && $route.matched[1].name === 'ProjectStructure'">
      <TTooltip :value="getToolTip({no_bim_account: true, disabled: !hasPermission('Upload IFC'), name: 'IFC Upload'})">
        <ButtonOutlined
            class="pl-2 pr-2 ml-2"
            icon="upload"
            text="Upload IFC"
            color="#fff"
            :is_disabled="!hasPermission('Upload IFC')"
            :height="36"
            @buttonClicked="setValue({key: 'show_ifc_import_dialog', value: true})"
          />
        </TTooltip>
    </template>
    <template #projectMessages>
      <div v-if="$route.matched[0] && $route.matched[0].name === 'Project'">
        <ProjectMessageButton
          icon="notifications"
          :show_badge="getMessagesProjectWarningActive($route.params.project_id).length !== 0"
          :badge_text="getMessagesProjectWarningActive($route.params.project_id).length"
          :user_notifications="getMessagesProjectNotificationActive($route.params.project_id)"
          :system_notifications="getMessagesProjectWarningActive($route.params.project_id)"
          />

      </div>
    </template>
    <template #projectStatus>
      <!-- TODO: better permission handling > only show if is pro user (if business: && is business project) -->
      <ProjectStatus
        v-if="$route.matched[1] && $route.matched[1].name === 'ProjectTaktPlan'"
        :status="getProjectStatus($route.params.project_id)"
        :can_update="hasPermission('Project Status UPDATE') && hasProjectPermission({
          project_id: $route.params.project_id,
          ppermission: 'Update Project information'
          })"
        @updateStatus="updateProjectStatus({
          project_id: $route.params.project_id,
          payload: { status: $event }
          })"
      />
    </template>
    <template #switch>

        <StandardSwitch
          v-if="$route.matched[1] && $route.matched[1].name === 'ProjectTaktPlan'"
          ticon="plane-takeoff"
          :value="isShowStatusBadges"
          @changeValue="setShowStatusBadges(!isShowStatusBadges)"
        />
        <StandardSwitch
          v-if="$route.matched[0] && $route.matched[0].name === 'MultiProjectSchedule'"
          ticon="plane-takeoff"
          :value="$store.state.View.show_wp_status_multiproject"
          @changeValue="setValue({ key: 'show_wp_status_multiproject', value: !$store.state.View.show_wp_status_multiproject })"
        />
    </template>
    <template #buttonsRight v-if="location === 'HistProject'">
      <v-btn @click="$router.push({name: 'ProjectTaktPlan'})"> back to live </v-btn>
    </template>
    <template #buttonsRight v-else>
      <NavBarButtonsRight v-if="is_logged_in && $route.name !== 'Simulation'"/>
      <template v-else-if="$route.name !== 'Simulation'">
        <v-btn @click="$router.push({name: 'Apply'})"> {{$t('Home.Home.Register.Apply')}} </v-btn>
        <v-btn :href="getLoginUrl">{{$t('Buttons.Login')}}</v-btn>
      </template>
    </template>
  </NavBar>
</template>

<script>
import store from '@/store/index'
import { mapState, mapGetters, mapActions } from 'vuex';

import NavBar from '@/components/AppLayout/NavBar.component.vue'
import NavigationButton from '@/components/AppLayout/NavigationButton.component.vue'
import WalletNavigation from '@/components/AppLayout/WalletNavigation.component.vue'

import ProjectStatus from '@/components/ProjectTaktPlan/ProjectStatus.component.vue'
import TaktPlanZoom from '@/components/ProjectTaktPlan/TaktPlanZoom.component.vue'

import ProjectTitle from '@/components/AppLayout/ProjectTitle.component.vue'
import ProjectMenu from '@/components/AppLayout/ProjectMenu.component.vue'
import EditButton from '@/components/AppLayout/EditButton.component.vue'
import NavBarTools from '@/components/AppLayout/NavBarTools.component.vue'
import NavBarButtonsRight from '@/components/AppLayout/NavBarButtonsRight.component.vue'
// import NavBarButtonsRightMobile from '@/components/AppLayout/NavBarButtonsRightMobile.component.vue'
// import NavBarSwitch from '@/components/AppLayout/NavBarSwitch.component.vue'
import StandardSwitch from '@/components/StandardComponents/StandardSwitch.component.vue'
// import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue'
// import StandardSlider from '@/components/StandardComponents/StandardSlider.component.vue'
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
import ProjectMessageButton from '@/components/AppLayout/ProjectMessageButton.component.vue'
import LocaleChanger from '@/components/LocaleChanger.component.vue';
import StandardMembersList from '@/components/StandardComponents/StandardMembersList.component.vue';
import ToggleCapsule from '@/components/WorkPackageWIP/ToggleCapsule.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TTooltip from '@/components/Taktify/TTooltip.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';

import { MultiWindowMixin } from '@/mixins/MultiWindow.mixin.js';

export default {
  props: ['is_logged_in'],
  components: {
    NavBar,
    NavigationButton,
    WalletNavigation,
    ProjectTitle,
    ProjectMenu,
    EditButton,
    NavBarTools,
    NavBarButtonsRight,
    // NavBarButtonsRightMobile,
    // NavBarSwitch,
    StandardSwitch,
    // StandardFlexBox,
    ProjectStatus,
    // StandardSlider,
    StandardBadge,
    ProjectMessageButton,
    LocaleChanger,
    TaktPlanZoom,
    StandardMembersList,
    ToggleCapsule,
    TText,
    TIcon,
    TTooltip,
    ButtonOutlined,
  },
  mixins: [
    MultiWindowMixin,
  ],
  data: () => ({
    taktplan_zoom: localStorage.getItem('taktplan_zoom') ? parseFloat(localStorage.getItem('taktplan_zoom')) : 1.1,
    multiproject_taktplan_zoom: localStorage.getItem('multiproject_taktplan_zoom') ? parseFloat(localStorage.getItem('multiproject_taktplan_zoom')) : 0.2,
    child_window: false,
    child_window_route_object: false,
  
    // multiWindow with LocalStorage
    multiWindowId: null,
    vueMultiWindow: {
      isActivated: false,
      active_element: {   // Aktives Element kann aus Prozess, aber auch Taktbereich, Geometrie oder Taktzeit sein
        type: 'testtype', // tworkpackages, tworksteps, ...
        id: 123,
        source: 'testsource',  // Quelle in der das Element angeklickt wurde, z.B. taktplan, projectstructure, ...
        project_id: 1234, // Project_id des aktiven Elements
      },
      windowData: []
    },
  }),

  computed: {
    location(){
      if ( this.$route.matched[1] && this.$route.matched[1].name === 'HistProject' ) {
        return 'HistProject';
      } 
      else {
        return '';
      }
    },
    getLiveSyncSettingFromCookie(){
      return localStorage.getItem('live_sync') !== "false";
    },
    ...mapGetters('Auth', [
      'hasPermission',
      'hasOneOfPermissions',
      'getUserLiveSync',
      'getToken',
      'getIDToken',
      'isCloudPrint',
      'getLoginUrl',
      'getUser',
      'hasBusiness',
    ]),
    ...mapGetters('Business', [
      'hasBusinessPermission',
    ]),
    ...mapGetters('Project', [
      'getProject',
      'isEditMode',
      'isShowStatusBadges',
      'hasProjectPermission',
      'getOwnTWorkPackages',
      'getProjectStatus',
      'getProjectStart',
      'isLoading'
    ]),
    ...mapGetters('ProjectCalendar', [
      'getDateFromTaktIndex',
      'getTaktIndexFromDate',
      'getCurrentTaktIndex',
    ]),
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects',
      'getUObjectsFiltered',
    ]),
    ...mapGetters('View', [
      'isShowOwnWps',
      'isSpatialView',
      'getCurrentProjectActiveUsers',
      'getCurrentProjectActiveEditor',
      'getTaktplanZoom',
      'isLoadingProjectOverview',
    ]),
    ...mapGetters('Message', [
      'getMessagesProjectWarningActive',
      'getMessagesProjectNotificationActive'
    ]),
    ...mapState('View', [
      'isMicroView'
    ]),
    localStorageMultiWindowUpdated() {
      // return this.$store.state.Ultra.localStorageMultiWindowUpdated;
      return this.$store.state.View.localStorageMultiWindowUpdated;
    }
  },
  watch: {
    // multiWindow TestPhilipp
    child_window_route_object(val) {
      console.log('------------t-tt-t--------');
      console.log(val);
      if (!val) {
          console.log('1');
          this.$router.push({name: 'ProjectTaktPlan'});
        } 
        // else if (val.object.type === 'tworkpackages') {
        //   console.log('yeeeeeeeeees');
        //   this.$router.push('/projects/585/wallet/takt/3')
        //   console.log(this.$route)
        // }
        else if (val.object.type === 'tworkpackages') {
          console.log('2');
          console.log(val);
          this.$router.push({
            name: 'TaktPlanWorkPackageInfo',
            params: {
              project_id: `${val.url.path[0].id}`,
              train_id: val.url.path[1].id,
              taktarea_id: val.url.path[2].id,
              twaggon_id: val.url.path[3].id,
              tworkpackage_id: val.url.path[4].id,
            }
          });
          console.log('2.2');
        } 
        else if (val.object.type.includes('steps')) {
          console.log('3');
          this.$router.push({
            name: 'TaktPlanWorkPackageWorkStepsDetails',
            params: {
              project_id: `${val.url.path[0].id}`,
              train_id: val.url.path[1].id,
              taktarea_id: val.url.path[2].id,
              twaggon_id: val.url.path[3].id,
              tworkpackage_id: val.url.path[4].id,
              content_id: val.url.path[5].id,
            }
          });
          console.log('3.2');

        }
    },
    taktplan_zoom: function() {
      document.body.style.setProperty('--taktplan_zoom', `${this.taktplan_zoom}`)
    },
    multiproject_taktplan_zoom: function() {
      document.body.style.setProperty('--taktplan_zoom', `${this.multiproject_taktplan_zoom}`)
    },
    // $route (to){
    //     if (to.name.includes('Multi')) {
    //       document.body.style.setProperty('--taktplan_zoom', `${this.multiproject_taktplan_zoom}`)
    //     } else {
    //       document.body.style.setProperty('--taktplan_zoom', `${this.taktplan_zoom}`)
    //     }
    // },

    // multiWindow with LocalStorage
    /**
     * Recognize changes to the router path and write them to LocalStroage for multiWindow.
     */
    $route() {
      // Condition für Entwicklung ausgestellt.
      // if (this.vueMultiWindow.isActivated && !this.multiWindowI)

      // Nur für parent multiWindow
      if (!this.multiWindowId) {
        // console.log(this.$route);
        // console.log(this.$route.params.project_id);
        // console.log(typeof this.$route.params.project_id);

        try {
          const routeConfig = {
            'TaktPlanWorkPackageInfo': { type: 'tworkpackages', param: 'tworkpackage_id', source: 'taktplan' },
            'TaktPlanWorkPackageWorkSteps': { type: 'tworkpackages', param: 'tworkpackage_id', source: 'taktplan' },
            'ProjectWalletWorkPackageInfo': { type: 'tworkpackages', param: 'tworkpackage_id', source: 'wallet' },
            'ProjectWalletWorkPackageWorkSteps': { type: 'tworkpackages', param: 'tworkpackage_id', source: 'wallet' },
            'TaktPlanWorkPackageWorkStepsDetails': { type: 'tworksteps', param: 'content_id', source: 'taktplan' },
            'ProjectWalletWorkPackageWorkStepsDetails': { type: 'tworksteps', param: 'content_id', source: 'wallet' },
            'TaktPlanWorkStepWorkPackageElementsDetails': { type: 'element', param: 'element_id', source: 'taktplan' },
            'TaktPlanWorkPackageElementsDetails': { type: 'element', param: 'element_id', source: 'taktplan' },
            'ProjectWalletWorkStepWorkPackageElementsDetails': { type: 'element', param: 'element_id', source: 'wallet' },
            'ProjectWalletWorkPackageElementsDetails': { type: 'element', param: 'element_id', source: 'wallet' },
            'TaktPlanWorkPackageElements': { type: 'tworkpackages', param: 'tworkpackage_id', source: 'taktplan' },
            'ProjectWalletWorkPackageElements': { type: 'tworkpackages', param: 'tworkpackage_id', source: 'wallet' },
            'TaktPlanTaktareaDetailsInfo': { type: 'taktareas', param: 'taktarea_id', source: 'taktplan' },
            'ProjectWalletTaktareaDetailsInfo': { type: 'taktareas', param: 'taktarea_id', source: 'wallet' },
            'TaktPlanWaggon': { type: 'twaggon', param: 'twaggon_id', source: 'taktplan' },
            'ProjectWalletTakt': { type: 'takt', param: 'takt_index', source: 'wallet' },
          };

          if (this.$route.name in routeConfig) {
            const config = routeConfig[this.$route.name];
            this.vueMultiWindow.active_element.type = config.type;
            this.vueMultiWindow.active_element.id = this.$route.params[config.param].toString();
            this.vueMultiWindow.active_element.source = config.source;
            this.vueMultiWindow.active_element.project_id = this.$route.params.project_id;
            localStorage.setItem('multiWindow', JSON.stringify(this.vueMultiWindow));
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    // multiWindow with LocalStorage
    /**Use Store to work around the problem that watcher does not react to added windowData in LocalStorage */
    localStorageMultiWindowUpdated(newValue) {
      if (newValue === true) {
        // console.log('localStorageMultiWindowUpdated:', newValue);
        try {
          let multiwindowLocalStorageString = localStorage.getItem("multiWindow");
          let parsedValue = JSON.parse(multiwindowLocalStorageString);
          if (parsedValue !== null) {
            this.vueMultiWindow = parsedValue;
            // console.log('this.vueMultiWindow überschrieben aus LocalStorageWert');
          }
        } catch (error) {
          console.error('Error parsing the new value from LocalStorage:', error);
        }
      }
      this.setValue({key: 'localStorageMultiWindowUpdated', value: false})
    },
  },
  methods: {
    /**Removes the multiWindow data of this window from the localStorage */
    removeWindowFromLocalStorage() {
      // Only for multiWindow children
      if (this.multiWindowId) {
        // keine alerts verwenden!!!
        // Werden von Chrome geblockt und verhindern Ausführen des restlichen Codes
        console.log('removeWindowFromLocalStorage');
        let multiWindow = JSON.parse(localStorage.getItem('multiWindow')) || {};
        multiWindow.windowData = multiWindow.windowData.filter(window => window.id !== this.multiWindowId);
        if (multiWindow.windowData.length === 0) {
          multiWindow.isActivated = false;
        }
        localStorage.setItem('multiWindow', JSON.stringify(multiWindow));
      }
    },

    // ToDo: Auslagern in MultiWindowMixin?
    /**
     * Transfers the information on the active element from the localstorage to the vue data of this view
     * @param {*} event Change Event from Event Listener
     */
    handleStorageChange(event) {
      if (event.key === 'multiWindow') {
        // console.log('handleStorageChange bei multiWindow erkannt');
        // console.log(event);
        try {
          // Versucht, den neuen Wert zu parsen und zuweisen
          let parsedValue = JSON.parse(event.newValue);
          if (parsedValue !== null) {
            this.vueMultiWindow = parsedValue;
            // console.log('this.vueMultiWindow überschrieben aus LocalStorageWert');
          }
        } catch (error) {
          // Fehlerbehandlung, falls das Parsen fehlschlägt
          console.error('Error parsing new value from LocalStorage:', error);
        }
      }
    },
    toggleMultiprojectWeekends() {
      this.setValue({ key: 'multiproject_skip_weekends', value: !this.$store.state.View.multiproject_skip_weekends });
      const mp = this.getUObject({ type: 'multiprojects', id: this.$route.params.multiproject_id });
      this.initializeMPCalendar(mp);
    },

    handleSelectZoom(evt){
      if (this.$route.name.includes('Multi')) {
        this.setValue({ key: 'multiproject_taktplan_zoom', value: evt });
        this.multiproject_taktplan_zoom = evt;
      } else {
        this.setTaktplanZoom(evt);
        this.updateTaktplanZoom(evt)
      }
    },
    showPrintButton(){
      if (this.$route.matched[0]) {
        if (['MultiProjectSchedule'].includes(this.$route.matched[0].name)) {
          return true;
        }
        if (this.$route.matched[1]) {
          if (['ProjectTaktPlan'].includes(this.$route.matched[1].name)) {
            return true;
          }
        }
        if (this.$route.matched[1]) {
          if (['ProjectWallet'].includes(this.$route.matched[1].name)) {
            return true;
          }
        }
        if (this.$route.matched[1]) {
          if (['ProjectWalletPrint'].includes(this.$route.matched[1].name)) {
            return true;
          }
        }
      }
      return false;
    },
    ...mapActions('Project', [
      'enterEditMode',
      'leaveEditMode',
      'setShowStatusBadges',
      'updateProjectStatus'
    ]),
    ...mapActions('MultiProject', [
      'initializeMPCalendar',
    ]),
    ...mapActions('Ultra', [
      'updateUObject',
      'undoLastAction',
    ]),
    ...mapActions('SnackBar', [
      'updateSnackbar'
    ]),
    ...mapActions('View', [
      'setShowOwnWps',
      'setDialogNewProjectShow',
      'setTaktplanZoom',
      'setMacroView',
      'setValue',
      'setTokenView',
      'setMicroView'
    ]),
    getToolTip(item){
      if (item.disabled) {
        if (item.pro_account) {
          return `${item.name} are part of the TAKT.ing PRO.account.`;
        }
        if (item.no_bim_account) {
          return `${item.name} requires the TAKT.ing BIM.module.`;
        }
        return `Your PROJECT.role is not allowed to use ${item.name}.`;

      }
      return `${item.name}`;
    },
    openPrintDialog() {
        let self = this;
        this.setValue({ key: 'is_printing_mode_loading', value: true })
        setTimeout(function() {
            self.setValue({ key: 'is_printing_mode', value: true });
        }, 400);
    },
    updateTaktplanZoom(zoom) {
        this.taktplan_zoom = zoom;
    },
    handleEditMode() {
        if (this.$route.matched[1] === 'ProjectTaktPlan' && this.$route.name !== 'ProjectTaktPlan' && this.$route.matched[2] && this.$route.matched[2] !== 'TaktPlanWaggon') {
            this.$router.push({ name: 'ProjectTaktPlan' });
        }
        if (this.isEditMode) {
            this.leaveEditMode({ project_id: this.$route.params.project_id }).then(() => {
                // if (this.$route.name !== 'ProjectTaktPlan') {
                //   this.$router.push({
                //     // name: this.$route.name.replace('Edit', '') // error occures?
                //     name: 'ProjectTaktPlan' // quickfix route back to taktplan
                //   });
                // }
            });
        } else {
            this.enterEditMode({ project_id: this.$route.params.project_id }).then(() => {
                if (this.$route.name.includes('MilestonesDetails')) {
                    this.$router.push({
                        name: this.$route.name.replace('Details', 'Edit')
                    });
                }
            });
        }
    },
    selectWalletDate(evt) {
        let takt_index = Math.max(this.getTaktIndexFromDate({ project_id: this.$route.params.project_id, date_string: evt }).index, 0);
        store.dispatch('ProjectWallet/requestProjectStepCards', {
                project_id: this.$route.params.project_id,
                takt_index: parseInt(takt_index) - 1,
            })
            .then(() => {
                store.dispatch('ProjectWallet/requestProjectStepCards', {
                        project_id: this.$route.params.project_id,
                        takt_index: parseInt(takt_index),
                    })
                    .then(() => {
                        store.dispatch('ProjectWallet/requestProjectStepCards', {
                                project_id: this.$route.params.project_id,
                                takt_index: parseInt(takt_index) + parseInt(1),
                            })
                            .then(() => {
                                this.$router.push({
                                    name: 'ProjectWalletTakt',
                                    params: {
                                        takt_index: takt_index,
                                        direction: 'none',
                                    }
                                })
                            });
                    });
            });
    },
    // changeMicroView() {
    //   if(this.isMicroView) {
    //     this.setValue({key: 'isMicroView', value: false})
    //   } else {
    //     this.switchMicroView(true);
    //     this.setValue({key: 'isMicroView', value: true})
    //   }

    // }
    },
    created(){
    if (this.$route.name && this.$route.name.includes('Multi')) {
      document.body.style.setProperty('--taktplan_zoom', `${this.multiproject_taktplan_zoom}`)
    } else {
      document.body.style.setProperty('--taktplan_zoom', `${this.taktplan_zoom}`)
    }
  },
  mounted() {
    // multiWindow with LocalStorage
    window.addEventListener('beforeunload', this.removeWindowFromLocalStorage);
    window.addEventListener('storage', this.handleStorageChange);

    // Initiales erkennen der windowId bei multiWindow
    let multiWindowIdString = new URLSearchParams(window.location.search).get('windowId');
    if (multiWindowIdString !== null) {
      try {
        this.multiWindowId = parseInt(multiWindowIdString, 10);
        // console.log(this.multiWindowId);
      } catch (error) {
        // console.error('Error parsing the multiWindowId:', error);
      }
    }
       if (this.multiWindowId && !isNaN(this.multiWindowId)) {
      // console.log('initiales Laden von vueMultiWindow aus LocalStorage');
      try {
        // Initiales Schreiben der multiwindow Daten aus LocalStorage in Vue data () der Komponente
        this.vueMultiWindow = JSON.parse(localStorage.getItem('multiWindow'));
        // Übertrag der multiWindowId in Session Storage für Nutzung in anderen Komponenten / nach Verändern der Route
        sessionStorage.setItem('multiWindowId', this.multiWindowId);
      } catch (error) {
        console.error('Error during initial parsing of multiwindow data from LocalStorage:', error);
      }
    }
  },
  beforeDestroy() {
    // multiWindow with LocalStorage
    window.removeEventListener('beforeunload', this.removeWindowFromLocalStorage());
    window.removeEventListener('storage', this.handleStorageChange);
    // _____________________________________________________________________
  },
}
</script>

<style>
.v-btn--active.no-active::before {
    opacity: 0 !important;
}

.active-user-dropdown {
    width: 300px;
    overflow-x: hidden;
    text-overflow: ellipsis;
}

.edit-btn-inline {
    display: inline-block;
}

.histproject-dropdown {
    max-height: 250px;
    overflow-y: auto;
}
</style>
